import { SparkIcon } from './Icons';
import { STAFF_ASSISTANT_NAME } from '@/lib/assistant';

/**
 * Leo's name with the AI spark in front, wherever his name shows, so a new user always knows what was
 * written by AI (Gary, 18 Oct). Buttons ("Return to Leo") keep the plain name.
 */
export function AiTag() {
  return <span className="chats-ai-tag" role="img" aria-label="AI"><SparkIcon /></span>;
}

export function AiLeo({ suffix = '' }: { suffix?: string }) {
  return <span className="chats-ai-leo"><AiTag />Leo{suffix}</span>;
}

/** The staff assistant (Ted) on the Ask screens, the same AI spark; name from lib/assistant (Gary, 1 Nov). */
export function AiStaff({ suffix = '' }: { suffix?: string }) {
  return <span className="chats-ai-leo"><AiTag />{STAFF_ASSISTANT_NAME}{suffix}</span>;
}
